import { Prec } from '@codemirror/state'
import { keymap } from '@codemirror/view'
import { changeCase, toggleRanges } from '../../commands/ranges.ts'
import { jumpToEnclosingCloseBrace } from '../../commands/cursor.ts'

export const shortcuts = () => {
  return Prec.high(
    keymap.of([
      {
        key: 'Ctrl-b',
        mac: 'Mod-b',
        preventDefault: true,
        run: toggleRanges('\\textbf'),
      },
      {
        key: 'Ctrl-i',
        mac: 'Mod-i',
        preventDefault: true,
        run: toggleRanges('\\textit'),
      },
      {
        key: 'Ctrl-u',
        mac: 'Mod-u',
        preventDefault: true,
        run: toggleRanges('\\underline'),
      },
      {
        key: 'Alt-u',
        mac: 'Alt-u',
        preventDefault: true,
        run: changeCase('upper'),
      },
      {
        key: 'Alt-l',
        mac: 'Alt-l',
        preventDefault: true,
        run: changeCase('lower'),
      },
      {
        key: 'Alt-t',
        mac: 'Alt-t',
        preventDefault: true,
        run: changeCase('title'),
      },
      {
        key: 'Alt-s',
        mac: 'Alt-s',
        preventDefault: true,
        run: changeCase('sentence'),
      },
      {
        key: 'Alt-b',
        mac: 'Alt-b',
        preventDefault: true,
        run: jumpToEnclosingCloseBrace,
      },
    ])
  )
}
